// This is an adaptation of jquery menu aim written in plain javascript - MML 11/1/18
/*
 * The following options can be passed to menuAim. All functions execute with
 * the relevant row's HTML element as the execution context ('this'):
 *
 *      .menuAim4i({
 *          // Function to call when a row is purposefully activated. Use this
 *          // to show a submenu's content for the activated row.
 *          activate: function() {},
 *
 *          // Function to call when a row is deactivated.
 *          deactivate: function() {},
 *
 *          // Function to call when mouse enters a menu row. Entering a row
 *          // does not mean the row has been activated, as the user may be
 *          // mousing over to a submenu.
 *          enter: function() {},
 *
 *          // Function to call when mouse exits a menu row.
 *          exit: function() {},
 *
 *          // Selector for identifying which elements in the menu are rows
 *          // that can trigger the above events. 
 *          rowSelector: "li.menu-row",
 *
 *          // You may have some menu rows that aren't submenus and therefore
 *          // shouldn't ever need to "activate." If so, filter submenu rows w/
 *          // this selector. Defaults to "*" (all elements).
 *          submenuSelector: "*",
 *
 *          // Direction the submenu opens relative to the main menu. Can be
 *          // left, right, above, or below. Defaults to "right".
 *          submenuDirection: "right"
 *      });
*/
var menuAim4i = function(){
	var extend = function(out) {
		out = out || {};
		for (var i = 1; i < arguments.length; i++) {
			if (!arguments[i]) { continue; }
			for (var key in arguments[i]) {
				if (arguments[i].hasOwnProperty(key)) { out[key] = arguments[i][key]; }
			}
		}
		return out;
	},	
	init = function(opts) {
		var menu = document.getElementsByClassName('cd-dropdown-content')[0],
		//var menu = menuElement,
		activeRow = null,
		mouseLocs = [],
		lastDelayLoc = null,
		timeoutId = null,
		options = extend({
			rowSelector: "li.menuRow",
			submenuSelector: "*",
			submenuDirection: "right",
			tolerance: 75,  
			enter: function(){},
			exit: function(){},
			activate: function(){},
			deactivate: function(){},
			exitMenu: function(){}
		}, opts),
		MOUSE_LOCS_TRACKED = 3, 
		DELAY = 300,
	
		mousemoveDocument = function(e) {
			mouseLocs.push({x: e.pageX, y: e.pageY});
	
			if (mouseLocs.length > MOUSE_LOCS_TRACKED) {
				mouseLocs.shift();
			}
		},
		mouseleaveMenu = function() {
			if (timeoutId) { clearTimeout(timeoutId); }
			if (options.exitMenu) {
				if (activeRow !== null) { 
					options.exitMenu(this);
					options.deactivate(activeRow); 
				}
				activeRow = null;
			}
		},
		mouseenterRow = function() {
			if (timeoutId) { clearTimeout(timeoutId); }
			if (options.enter){
				options.enter(this);
			}
			possiblyActivate(this);
		},
		mouseleaveRow = function() { 
			if(options.exit){
				options.exit(this); 
			}
		},
		clickRow = function() { 
			activate(this); 
		},
		activate = function(row) {
			if (row == activeRow) { return; }
			if (activeRow !== null) { options.deactivate(activeRow); }
			options.activate(row);
			activeRow = row;
		},
		possiblyActivate = function(row) {
			var delay = activationDelay();
	
			if (delay) {
				timeoutId = setTimeout(function() {
					possiblyActivate(row);
				}, delay);
			} else {
				activate(row);
			}
		},
		activationDelay = function() {
			if (!activeRow || (activeRow) !== (options.submenuSelector)) { return 0; }
			var offset = menu.getBoundingClientRect(),
			upperLeft = {
				x: offset.left,
				y: offset.top - options.tolerance
			},
			upperRight = {
				x: offset.left + menu.offsetWidth,
				 y: upperLeft.y
			},
			lowerLeft = {
				x: offset.left,
				y: offset.top + menu.offsetHeight + options.tolerance
			},
			lowerRight = {
				x: offset.left + menu.offsetWidth,
				y: lowerLeft.y
			},
			loc = mouseLocs[mouseLocs.length - 1],
			prevLoc = mouseLocs[0];
			
			if (!loc) { return 0; }
			if (!prevLoc) { prevLoc = loc; }
	
			if (prevLoc.x < offset.left || prevLoc.x > lowerRight.x ||
				prevLoc.y < offset.top || prevLoc.y > lowerRight.y) {
	                    return 0;
			}
	
			if (lastDelayLoc &&
				loc.x == lastDelayLoc.x && loc.y == lastDelayLoc.y) {
	                    return 0;
			}
	
			function slope(a, b) { return (b.y - a.y) / (b.x - a.x); }
	
			var decreasingCorner = upperRight,
			increasingCorner = lowerRight;

			if (options.submenuDirection == "left") {
				decreasingCorner = lowerLeft;
				increasingCorner = upperLeft;
			} else if (options.submenuDirection == "below") {
	                    decreasingCorner = lowerRight;
	                    increasingCorner = lowerLeft;
			} else if (options.submenuDirection == "above") {
	                    decreasingCorner = upperLeft;
	                    increasingCorner = upperRight;
			}
	
			var decreasingSlope = slope(loc, decreasingCorner),
			increasingSlope = slope(loc, increasingCorner),
			prevDecreasingSlope = slope(prevLoc, decreasingCorner),
			prevIncreasingSlope = slope(prevLoc, increasingCorner);
			
			if (decreasingSlope < prevDecreasingSlope && increasingSlope > prevIncreasingSlope) {
	                    lastDelayLoc = loc;
	                    return DELAY;
			}
			lastDelayLoc = null;
			return 0;
		};
		var rows = menu.querySelectorAll(options.rowSelector);
		// EVENT LISTENERS
		Array.prototype.forEach.call(rows, function(el, index, array){
			el.addEventListener("mouseenter", mouseenterRow);
			el.addEventListener("mouseleave", mouseleaveRow);
			el.addEventListener("click", clickRow);
		});
		
		menu.addEventListener("mouseleave", mouseleaveMenu);
		document.addEventListener("mousemove", mousemoveDocument);	
	};

	return{
		init: init
	};
};

(function(){
	menuAim4i().init();
})();